import { z } from 'zod';
import { MoneyHufSchema } from '../types/common.types';

/**
 * ADR-037 Amendment-1 — Per-gép manuális engedmény (Phase-2 b).
 *
 * 15% partner-cap **FELOLDVA** (Zoli/Zsuzsi kliens-ratify 2026-06-07) →
 * az effektív felső korlát = **role-cap** (`DISCOUNT_LIMITS_BY_ROLE`), a hard-15% partner-plafon megszűnt.
 * A cap-enforcement BE-oldali (role-alapú clamp); ez a schema a BE↔FE **contract-shape**.
 *
 * A per-gép engedmény a `rental.subtotal`-ra (gép-bérleti sor) számol, az auto-tier (ADR-048) exempt.
 */

export const RentalItemDiscountInputSchema = z.object({
  rentalItemId: z.string().uuid(),
  /** kért engedmény %; a tényleges limit a role-cap (BE-enforced, a hard-15% FELOLDVA) */
  discountPct: z.number().min(0).max(100),
  reason: z.string().max(500).optional(),
});
export type RentalItemDiscountInput = z.infer<typeof RentalItemDiscountInputSchema>;

export const RentalDiscountApplySchema = z.object({
  rentalId: z.string().uuid(),
  /** per-gép batch — minden RentalItemhez külön % */
  items: z.array(RentalItemDiscountInputSchema).min(1),
});
export type RentalDiscountApply = z.infer<typeof RentalDiscountApplySchema>;

/** Per-item eredmény (a role-cap-clamp után). */
export const RentalItemDiscountResultSchema = z.object({
  rentalItemId: z.string().uuid(),
  /** a ténylegesen alkalmazott % (role-cap-clamp után lehet < kért) */
  appliedPct: z.number(),
  discountAmount: MoneyHufSchema,
  /** true ha a role-cap visszavágta a kért %-ot */
  cappedByRole: z.boolean(),
});
export type RentalItemDiscountResult = z.infer<typeof RentalItemDiscountResultSchema>;

export const RentalDiscountApplyResultSchema = z.object({
  rentalId: z.string().uuid(),
  items: z.array(RentalItemDiscountResultSchema),
  subtotalAfterDiscount: MoneyHufSchema,
  totalDiscountAmount: MoneyHufSchema,
  vatAmount: MoneyHufSchema,
  finalAmount: MoneyHufSchema,
});
export type RentalDiscountApplyResult = z.infer<typeof RentalDiscountApplyResultSchema>;
